import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import HtmlText from '~/src/components/htmlText/HtmlText';

import {classNames} from '~/src/utilities/helpers/css';
import {toPascalCase} from '~/src/utilities/helpers/string';
import {SettingsContext} from '~/src/components/context/SettingsContext';

import css from './Crosshead.module.scss';

const Crosshead = ({style = {}, ...props}) => {
    const {crossheadType} = style;
    const type = `type${toPascalCase(crossheadType || 'Standard')}`;
    const {siteArea} = useContext(SettingsContext);

    const className = classNames(css, 'crosshead', siteArea, type);

    return <HtmlText as="h3" className={className} data-testid="Crosshead" {...props} />;
};

if (process.env.NODE_ENV === 'development') {
    Crosshead.propTypes = {
        type: PropTypes.oneOf(['crosshead']).isRequired,
        htmlText: PropTypes.string.isRequired,
        style: PropTypes.shape({
            crossheadType: PropTypes.string
        })
    };
}

export default Crosshead;
